import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Typography, List, ListItem, ListItemText, Box, CircularProgress, Grid, Paper, Divider, Link } from '@mui/material';
import { Facebook, Instagram, Twitter, LinkedIn, YouTube } from '@mui/icons-material';



const API_URL = process.env.REACT_APP_API_URL;

function ViewUser() {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);

  
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/users/`)  // Replace with your actual backend URL
      .then(response => {
        setUsers(response.data);
      })
      .catch(error => {
        console.error('There was an error fetching users!', error);
      });
  }, []);

  const fetchUserDetails = (userId) => {
    setLoading(true);
    axios.get(`${API_URL}/user/${userId}/`)  // Replace with your actual backend URL
      .then(response => {
        setUserDetails(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching user details', error);
        setLoading(false);
      });
  };

  return (
    <Container>
      <Typography variant="h4" component="h1" gutterBottom>
        Total Users: {users.length}
      </Typography>
      
      <List>
        {users.map((user, index) => (
          <ListItem button key={user.id} onClick={() => fetchUserDetails(user.id)}>
            <ListItemText 
              primary={`#${index + 1} ${user.name} ${user.surname}`} 
              secondary={`Status: ${user.online ? 'Online' : 'Offline'}`}  // Show online status
            />
          </ListItem>
        ))}
      </List>

      {loading ? (
        <CircularProgress />
      ) : (
        userDetails && (
          <Box mt={4}>
            <Typography variant="h5" gutterBottom>User Details</Typography>
            <Paper elevation={3} sx={{ padding: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6">Personal Information</Typography>
                  <Typography>Name: {userDetails.name} {userDetails.surname}</Typography>
                  <Typography>Email: {userDetails.email}</Typography>
                  <Typography>Contact: {userDetails.contact}</Typography>
                  <Typography>Gender: {userDetails.gender}</Typography>
                  <Typography>Date of Birth: {userDetails.dob}</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="h6">Professional Details</Typography>
                  <Typography>Experience: {userDetails.experience} years</Typography>
                  <Typography>Rating: {userDetails.rating}</Typography>
                  <Typography>Languages: {userDetails.languages}</Typography>
                  <Typography>Location: {userDetails.city}, {userDetails.state}, {userDetails.country}, {userDetails.pincode}</Typography>
                </Grid>
              </Grid>
              <Divider sx={{ my: 2 }} />
              <Typography variant="h6">About</Typography>
              <Typography>{userDetails.about}</Typography>

              <Divider sx={{ my: 2 }} />
              {userDetails.image && (
                <Box>
                  <Typography variant="h6">Profile Image</Typography>
                  <img src={`http://127.0.0.1:8000${userDetails.image}`} alt="User" width={150} height={150} />
                </Box>
              )}

              {/* Social Media Links */}
              <Divider sx={{ my: 2 }} />
              <Typography variant="h6">Social Media</Typography>
              <Box display="flex" gap={2}>
                {userDetails.facebook && (
                  <Link href={userDetails.facebook} target="_blank" rel="noopener noreferrer">
                    <Facebook color="primary" />
                  </Link>
                )}
                {userDetails.instagram && (
                  <Link href={userDetails.instagram} target="_blank" rel="noopener noreferrer">
                    <Instagram color="secondary" />
                  </Link>
                )}
                {userDetails.x && (
                  <Link href={userDetails.x} target="_blank" rel="noopener noreferrer">
                    <Twitter color="primary" />
                  </Link>
                )}
                {userDetails.linkedin && (
                  <Link href={userDetails.linkedin} target="_blank" rel="noopener noreferrer">
                    <LinkedIn color="primary" />
                  </Link>
                )}
                {userDetails.youtube && (
                  <Link href={userDetails.youtube} target="_blank" rel="noopener noreferrer">
                    <YouTube color="error" />
                  </Link>
                )}
              </Box>

              {/* User Preferences */}
              <Divider sx={{ my: 2 }} />
              <Typography variant="h6">User Preferences</Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle1">Sections</Typography>
                  <Typography>{userDetails.preferences?.sections.join(", ")}</Typography>

                  <Typography variant="subtitle1">Subsections</Typography>
                  <Typography>{userDetails.preferences?.subsections.join(", ")}</Typography>

                  <Typography variant="subtitle1">Languages</Typography>
                  <Typography>{userDetails.preferences?.languages.join(", ")}</Typography>

                  <Typography variant="subtitle1">Specialized Fields</Typography>
                  <Typography>{userDetails.preferences?.specialized_fields.join(", ")}</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle1">Roles</Typography>
                  <Typography>{userDetails.preferences?.roles.join(", ")}</Typography>

                  <Typography variant="subtitle1">Recently Viewed Post</Typography>
                  <Typography>{userDetails.preferences?.recent_viewed_post}</Typography>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        )
      )}
    </Container>
  );
}

export default ViewUser;
